import { Grid } from "@mui/material";
import FilterDatePicker from "components/FilterDatePicker";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { CompletionsFilter } from "services/organizationPortalClient";
import { setTimeToEndOfDay } from "utils/dateUtils";
import SelectCertificateProfession from "pages/Certificates/SelectCertificateProfession";
import SelectSkuFormat from "pages/Certificates/SelectSkuFormat";
import { CommonFilter, useIsFilterApplied } from "@knowfully/ui.common";

type CertificatesFilterProps = {
  onChange: (filter: CompletionsFilter) => void;
};

export default function CertificatesSearchFilter({
  onChange,
}: Readonly<CertificatesFilterProps>) {
  const [filter, setFilter] = useState({} as CompletionsFilter);
  const { formatMessage: t } = useIntl();

  const isFilterApplied = useIsFilterApplied(filter, []);

  const onChangeInternal = (prop: keyof CompletionsFilter, val: any) => {
    setFilter((prev) => ({ ...prev, [prop]: val }) as CompletionsFilter);
  };

  // Auto-apply filters to parent on any change
  useEffect(() => {
    onChange(filter);
  }, [filter, onChange]);

  const clearFilter = () => {
    setFilter({} as CompletionsFilter);
  };

  return (
    <CommonFilter
      searchText={filter.searchText}
      onSearchTextChange={(val: string | undefined) => onChangeInternal("searchText", val)}
      onClear={clearFilter}
      isFilterApplied={isFilterApplied}
      searchLabel={t({ id: "searchByNameEmailTitle" })}
    >
      <Grid item xs={12} sm={12} md={4}>
        <SelectSkuFormat
          value={filter.skuFormatId}
          onChange={(value) => onChangeInternal("skuFormatId", value)}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <SelectCertificateProfession
          value={filter.professionIds ?? []}
          onChange={(value) => onChangeInternal("professionIds", value)}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={2}>
        <FilterDatePicker
          label={t({ id: "startDate" })}
          value={filter.startDate}
          onChange={(value) => onChangeInternal("startDate", value)}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={2}>
        <FilterDatePicker
          label={t({ id: "endDate" })}
          value={filter.endDate}
          onChange={(value) =>
            onChangeInternal("endDate", setTimeToEndOfDay(value))
          }
        />
      </Grid>
    </CommonFilter>
  );
}
